import { api } from "../rtk";
import { ENDPOINTS } from "../url";

export const commonApi = api.injectEndpoints({
    endpoints: (builder) => ({
        uploadMedia: builder.mutation({
            query: (data) => ({
                url: ENDPOINTS.UPLOAD_MEDIA,
                method: 'POST',
                body: data,
                // Content-Type is multipart/form-data, but RTK Query/fetch handles this automatically if body is FormData
                // so we don't need to manually set it.
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useUploadMediaMutation } = commonApi;
